import { render, staticRenderFns } from "./Tokushoho.vue?vue&type=template&id=034984f4&"
import script from "./Tokushoho.vue?vue&type=script&lang=js&"
export * from "./Tokushoho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports